import React, { FC, ReactNode } from "react";
import css from "./styles.module.scss";

interface IBorderBlockProps {
  children: ReactNode;
}

const BorderBlock: FC<IBorderBlockProps> = ({ children }) => {
  return <div className={css.BorderBlock}>{children}</div>;
};

export default BorderBlock;
